<template>
  <div>
    <van-dialog v-model="show"
                class="unicom-auth-dialog"
                :title="title"
                :show-cancel-button="showCancel"
                :show-confirm-button="showConfirm"
                :overlay="false"
              >
      <img src="@/assets/img/auth/dialog_money.gif" />
      <div class="text" v-if="!isBorrowForward">
        <h3>您已通过初步审核</h3>
        <p>继续完成认证最高可领取20万额度</p>
      </div>
      <div class="text" v-else>
        <h3>您已获得额度</h3>
        <p>只差一步就能完成借款申请</p>
      </div>
      <footer>
        <button class="cm-bg cm-button" @click="handleGoOn">继续认证</button>
        <button class="gray" @click="handleGoHome">狠心离开</button>
      </footer>
    </van-dialog>
    <van-overlay :show="show"></van-overlay>
  </div>
</template>

<script>
import { setInterceptBack, GoH5Home } from '@/config/utils'

export default {
  name: 'authDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    showConfirm: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: true
      // isBorrowForward: false
    }
  },
  created () {
    // this.isBorrowForward = isBorrowForward(localStorage.getItem('category'))
  },
  mounted () {
    this.$nextTick(() => {
      const div = document.createElement('div')
      div.classList.add('van-modal')
      div.style['z-index'] = 2000
      document.querySelector('.unicom-auth-dialog').parentElement.appendChild(div)
      document.querySelector('.unicom-auth-dialog').style['z-index'] = 2001
    })
  },
  methods: {
    handleGoOn () {
      this.show = !this.show
      this.handleRemoveMask()
    },
    handleGoHome () {
      setInterceptBack(undefined, false)
      this.handleRemoveMask()
      this.show = false
      if (location.href.includes('auth/result')) {
        GoH5Home()
      } else {
        this.$router.push({ name: 'auth_result' })
      }
    },
    handleRemoveMask () {
      [...document.querySelectorAll('.van-modal')].forEach(node => {
        node.parentElement.removeChild(document.querySelector('.van-modal'))
      })
    }
  }
}
</script>

<style lang="less">
.unicom-auth-dialog {
    width: 5.4rem;
    height: 5.48rem;
    padding: .26rem .32rem .4rem;
    background: #FFFFFF;
    border-radius: 0.1rem;
    font-size: 0.32rem;
    text-align: center;
    box-sizing: border-box;
    img{
      width: 1.6rem;
      height: 1.6rem;
      margin: .2rem auto .52rem;
    }
    .text{
      h3{
        margin-bottom: .2rem;
        line-height: .32rem;
      }
      p{
        font-weight: normal;
        font-size: .28rem;
        line-height: .4rem;
        color: #999;
      }
    }
    footer{
      margin-top: .46rem;
      button{
        width: 100%;
        height: .8rem;
        line-height: .8rem;
        &.gray{
          color: #6B7082;
          font-size: .28rem;
          height: .52rem;
          line-height: .52rem;
          margin-top: .06rem;
        }
      }
    }
  }
</style>
